import createWrappedField from 'ddiForm/wrapped/createWrappedField'
import IS from '../../components/IndexSearchMobile'

export default createWrappedField({
  Component: IS,
  name: 'DDIIndexSearchMobile'
})
